module.exports = __webpack_public_path__ + "static/media/logo.e049a8fd.png";